<template>
<div class="cont-nav">
  <div class="lang-selector">
    <button @click="changeLanguage('it')" :class="{ active: currentLocale === 'it' }">IT</button>
    <button @click="changeLanguage('en')" :class="{ active: currentLocale === 'en' }">EN</button>
    <button @click="changeLanguage('es')" :class="{ active: currentLocale === 'es' }">ES</button>
  </div>
  <div id="nav">
    <router-link to="/">{{ $t('home') }}</router-link> 
  </div>
</div>
  <router-view/>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'App',
  setup() {
    const { locale } = useI18n()
    return { locale }
  },
  data: function() {
    return {
      currentLocale: localStorage.getItem('user-language') || 'it'
    }
  },
  methods: {
    changeLanguage(lang) {
      this.locale = lang
      this.currentLocale = lang
      localStorage.setItem('user-language', lang)
    }
  },
  created() {
    const savedLang = localStorage.getItem('user-language')
    if (savedLang) {
      this.locale = savedLang
    }
  }
}
</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@100&family=Fredericka+the+Great&family=Kelly+Slab&display=swap');
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 25px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: e0e0e0;
  padding:0;
  width: 100vw;
  min-height: 100vh;
  overflow-y: auto;
}

#nav {
  padding-top: 2vh;
  height: 8vh;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

body {
  height: 100vh;
  padding: 0px;
  margin: 0px;
  
}
</style>
